/* eslint-disable */
import { getInstance } from "./authWrapper";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  if (to.query && to.query.agency_id) {
    authService.saveAgencyId(to.query.agency_id);
  }

  if (to.query && to.query.rsos_token) {
    authService.saveRsosToken(to.query.rsos_token);
  }

  const fn = () => {
    if (authService.isAuthenticated) {
      // if (!authService.rsosToken) {
      //   return next();
      // } else {
      //   authService.logout({ returnTo: window.location.origin })
      //   return next(false);
      // }
      return next();
    } else {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      return next(false);
    }
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }

    return next(false);
  });
};
